import { NgModule } from '@angular/core'
import { BvCommentsComponent } from './list/list.component'
import { BvCommentComponent } from './comment/comment.component'
import { MatMenuModule } from '@angular/material/menu'

import { CommonModule } from '@angular/common'
import { IconsModule } from '@ziptility/icons'


@NgModule({
    imports: [CommonModule, MatMenuModule, IconsModule, BvCommentsComponent, BvCommentComponent],
    exports: [BvCommentsComponent, BvCommentComponent],
    providers: [],
})
export class BvCommentsModule {}
